module.exports = __webpack_public_path__ + "static/together_img1@2x-54d9164107d5122cfdb7a4926ccb438d.png";